import { bse as schemaBse } from './schemas';
import apiClient from './apiClient';
import BseDataStore from '../../datastores/BseDataStore';

class BseDataStoreGraphQL implements BseDataStore {
  client = apiClient();

  async getFormBse(requestId: number) {
    try {
      const response = await this.client.query({
        query: schemaBse.getFormBse,
        variables: { requestId }
      });
      const { formBSE } = response.data && response.data.procedures;
      return formBSE;
    } catch (error) {
      throw new Error('error in getFormBse');
    }
  }

  async registerBse(
    operationNumber: number,
    origin: string,
    fields: any,
    UT: boolean
  ) {
    try {
      const response = await this.client.mutate({
        mutation: schemaBse.registerBse,
        variables: {
          operationNumber,
          origin,
          fields,
          UT
        }
      });
      return response.data.saveFormBSE;
    } catch (error) {
      throw new Error('error schemaScholarships');
    }
  }

  async activatePayOrder(operationNumber: number, origin: string) {
    try {
      const response = await this.client.mutate({
        mutation: schemaBse.activatePayOrder,
        variables: {
          operationNumber,
          origin
        }
      });
      return response?.data?.activatePayOrderScholarshipSocioEconomic;
    } catch (error) {
      throw new Error('error activatePayOrderScholarshipSocioEconomic');
    }
  }

  async processBse(idRequest: string, test: boolean) {
    try {
      const response = await this.client.mutate({
        mutation: schemaBse.processBse,
        variables: {
          idRequest,
          test
        }
      });
      return response.data.requestProcessBSE;
    } catch (error) {
      throw new Error('error in ProcessBse');
    }
  }

  async getBseDocument(requestId: number) {
    try {
      const response = await this.client.query({
        query: schemaBse.getBseDocument,
        variables: { requestId }
      });
      return response?.data?.procedures?.formBSE?.documents;
    } catch (error) {
      throw new Error('error in getFormBse');
    }
  }

  async getStateBse(idProcedure: number, operationNumber: number) {
    try {
      const response = await this.client.query({
        query: schemaBse.getStateBse,
        variables: { idProcedure, operationNumber }
      });
      const { proceduresEvaluationScholarshipSocioEconomicDetail } =
        response.data && response.data.student;
      return proceduresEvaluationScholarshipSocioEconomicDetail;
    } catch (error) {
      throw new Error('error in getStateBse');
    }
  }

  async uploadBseDocument(requestId: number, data: any) {
    try {
      const response = await this.client.mutate({
        mutation: schemaBse.uploadBseDocument,
        variables: { idRequest: String(requestId), ...data }
      });
      return response.data.requestDocumentUpload;
    } catch (error) {
      throw new Error('error in uploadBseDocument');
    }
  }

  async deleteFileBse(idFile: number) {
    try {
      const response = await this.client.mutate({
        mutation: schemaBse.deleteFileBse,
        variables: {
          idFile
        }
      });
      return response?.data?.response;
    } catch (error) {
      throw new Error('error schemaScholarships');
    }
  }
}

export default BseDataStoreGraphQL;
